import urls from "../utils/urls"
import { get,post} from '../utils/http'
const state= {
    
    result:{},
    
    code:0
    
}
const mutations={
   
    agent_index(state,value){
        
        if(value.type=="get"){

            get(urls.admin.agent.index,value).then((result)=>{
          
         
         
                if (!("level1_name" in result.data)) {
                    result.data['level1_name'] = ""
        
                }
                if (!("level2_name" in result.data)) {
                    result.data['level2_name'] = ""
        
                }
                if (!("level3_name" in result.data)) {
                    result.data['level3_name'] = ""
        
                }
                if (!("level1_discount" in result.data)) {
                    result.data['level1_discount'] = ""
        
                }
                if (!("level2_discount" in result.data)) {
                    result.data['level2_discount'] = ""
        
                }
                if (!("level3_discount" in result.data)) {
                    result.data['level3_discount'] = ""
        
                }
                if (!("inventory" in result.data)) {
                    result.data['inventory'] = 0
        
                }
                if (!("amount" in result.data)) {
                    result.data['amount'] = 0.0
        
                }
                if (!("balance_due" in result.data)) {
                    result.data['balance_due'] = 0.0
        
                }
                if (!("allow_balance_due" in result.data)) {
                    result.data['allow_balance_due'] = 0
        
                }
                if (!("confirm" in result.data)) {
                    result.data['confirm'] = 0
        
                }
               
                state.result=result
             
              
             
                 
              });

        }else{
            post(urls.admin.agent.index,value).then((result)=>{
          
              
                
                if (!("level1_name" in result.data)) {
                    result.data['level1_name'] = ""
        
                }
                if (!("level2_name" in result.data)) {
                    result.data['level2_name'] = ""
        
                }
                if (!("level3_name" in result.data)) {
                    result.data['level3_name'] = ""
        
                }
                if (!("level1_discount" in result.data)) {
                    result.data['level1_discount'] = ""
        
                }
                if (!("level2_discount" in result.data)) {
                    result.data['level2_discount'] = ""
        
                }
                if (!("level3_discount" in result.data)) {
                    result.data['level3_discount'] = ""
        
                }
                if (!("inventory" in result.data)) {
                    result.data['inventory'] = 0
        
                }
                if (!("amount" in result.data)) {
                    result.data['amount'] = 0.0
        
                }
                if (!("balance_due" in result.data)) {
                    result.data['balance_due'] = 0.0
        
                }
                if (!("allow_balance_due" in result.data)) {
                    result.data['allow_balance_due'] = 0
        
                }
                if (!("confirm" in result.data)) {
                    result.data['confirm'] = 0
        
                }
                
                
                state.result=result
             
              
             
                 
              });

        }
       
    },
    
    editAddress(state,value){
        
        state.id=value.id

       
       if(value.type=="get"){

       
        get(urls.address.edit,{id:value.id}).then((result)=>{
          
           
           
          
            state.result=result.data
         
         
          
         
             
          });


       }else{
       
        post(urls.address.edit,value).then((result)=>{
          
          
            if(result.code==404){
               
                return
             
              
               
            }

            state.result=result
          
         
         
          
         
             
          });
       }
       
        
    },
    deleteAddress(state,value){

        
        post(urls.address.delete,value).then((result)=>{
          
            
            state.result=result.data
            state.address_id=result.address_id
          
         
          
         
             
          });
    },
    

}
const  actions={
    agentIndexAction(context,value){
       
        context.commit("agent_index",value)
       
    },
    
    deleteAddressAction(context,value){
       
        
        context.commit("deleteAddress",value)
       
    },
    
  
    
  
    
   

}

export default {state,mutations,actions}